module.exports = __webpack_public_path__ + "static/media/dajianshan_plant.93e1da6a.png";